import React from 'react';
import propTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';
import './Dedications.scss';
import { MOBILE } from '../utils/widgetInfoDefaults';

const Dedication = ({ optinData, name, deviceType }) => {
	const labels = useLabels();

	if (!optinData) {
		return null;
	}
	const { lovePromiseCommitment } = optinData.optIns;

	const dedicationTitle = labels
		.get('SUBARU_LOVE_ACCOUNT_DEDICATED_PROMISE_COPY')
		.replace('%s', name);

	const charityOrderMap = [
		'animalCharity',
		'environmentCharity',
		'educationCharity',
		'communityCharity',
		'healthCharity'
	];
	// Filter out any non-charity fields and any empty charity fields
	const includedCharities = Object.keys(optinData.optIns).filter((field) => {
		if (field.includes('Charity') && optinData.optIns[field] !== '')
			return field;
		return null;
	});

	// Re-Order Charities into correct order
	const charityMap = charityOrderMap.filter((element) => {
		if (includedCharities.includes(element)) return element;
		return null;
	});

	const camelCaseToKebabCase = (str) =>
		str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();

	return (
		<div className="lp-dedications">
			<h3 className="ddc-font-size-xlarge lp-dedications-header mb-4">
				{dedicationTitle}
			</h3>
			{lovePromiseCommitment && <p>{lovePromiseCommitment}</p>}
			{charityMap.map((charity) => {
				return (
					<div key={charity} className="row my-4 charity-block">
						<div className="col-xs-12 col-sm-2">
							<i
								className={`mx-auto ${camelCaseToKebabCase(
									charity
								)}`}
							/>
						</div>
						<div
							className={`col-xs-12 col-sm-10 ${
								deviceType === MOBILE
									? 'line-height-24px text-center'
									: ''
							}`}
						>
							<p className="font-weight-bold">
								{optinData.optIns[charity].replace(/\|/g, ', ')}
							</p>
						</div>
					</div>
				);
			})}
		</div>
	);
};

const DedicationPropTypes = {
	optinData: propTypes.shape({
		optIns: propTypes.shape({
			lovePromiseCommitment: propTypes.string
		})
	}).isRequired,
	name: propTypes.string.isRequired,
	deviceType: propTypes.string.isRequired
};

Dedication.propTypes = DedicationPropTypes;

export default Dedication;
